import { gql as e } from "@apollo/client";
const r = e`
  query GetOffChainTokenBalances($input: ClaimableRewardBalanceFilterInput) {
    getClaimableRewardBalances(input: $input) {
      income
      rewardInfo {
        decimal
        network
        rewardName
        rewardTokenAddress
        rewardTokenID
        rewardType
        staticAssetKey
        tokenErcType
      }
    }
  }
`;
export {
  r as default
};
//# sourceMappingURL=getOffChainTokenBalances.js.map
